import React, { useState } from "react";
import {
    getIndicatorUser,
    updateIndicatorUser
} from "../../services/Indicators.service";
import {Button, OverlayTrigger, Popover} from "react-bootstrap";
import {format, parseISO} from "date-fns";
import {useUser} from "../../store/providers/app";
import {useMutation, useQuery, useQueryClient} from "react-query";
import {toast} from "react-toastify";
import {i18n} from "../../translate/i18n";
import { isAfter, parse } from 'date-fns';
import {Tooltip} from "../Tooltip";


export const UsersIndicator = ({indicatorId, updateAuthStatus, status}) => {

    const [respondents, setRespondents] = useState([])
    const [leaders, setLeaders] = useState([])

    const {isFetching} = useQuery(['indicators_users', indicatorId],
        () => {
            return getIndicatorUser(indicatorId)
        }, {
            onSuccess: (response) => {
                const leaders = response.filter(user => user?.type === 1)
                const respondents = response.filter(user => user?.type === 2)

                setLeaders(leaders)
                setRespondents(respondents)

                let isComplete;

                if( status === 'draft') {
                    //para o respondente avancar todos os respondentes devem ter finalizado
                    isComplete = respondents.length && respondents.every(user => user.finished === 1);
                } else if(status === 'approval_esg') {
                    //para o lider esg avancar tanto os repondentes como lideres devem ter finalizado
                    isComplete = response.length && response.every(user => user.finished === 1);
                } else {
                    isComplete = true
                }

                updateAuthStatus(isComplete)
            },
            onError: (err) => {
                console.log('erro lista de indicadores ->', err)
                toast.error('Falha na requisição');
            },
            retry: 1,
            refetchOnWindowFocus: false,
            keepPreviousData: true,
        }
    )

    if(isFetching) return (<div className="spinner-border spinner-border-sm mt-2 text-secondary" role="status">
                            <span className="visually-hidden">Loading...</span>
                           </div>)

    return (
        <>
            <OverlayTrigger trigger="click" placement="left" overlay={
                <Popover>
                    <Popover.Body className="p-3">
                        <div className="d-flex flex-column">
                            <span className="fw-bolder">Líderes ESG</span>
                            <ContentUsers
                                users={leaders}
                                indicatorId={indicatorId}
                                status={status}
                                statusAuth='approval_esg'
                            />
                        </div>
                        <div className="d-flex flex-column border-top mt-3">
                            <span className="fw-bolder">Respondentes</span>
                            <ContentUsers
                                users={respondents}
                                indicatorId={indicatorId}
                                status={status}
                                statusAuth="draft"
                            />
                        </div>
                    </Popover.Body>
                </Popover>
            }>
                <Button variant="success" className="btn-sm">
                    <Tooltip label="Líder ESG/Respondente">
                        <i className="bi bi-people"/>
                    </Tooltip>
                </Button>
            </OverlayTrigger>
        </>
    )
}

const ContentUsers = ({ users, indicatorId, status, statusAuth }) => {

    const { user } = useUser()
    const queryClient = useQueryClient()

    const isOverdue = (date) => {
        const currentDate = new Date();
        const dateToCompare = parse(date, 'yyyy-MM-dd HH:mm:ss', new Date());
        return isAfter(dateToCompare, currentDate);
    }

    const userMutations = useMutation(async (data) => {
            return updateIndicatorUser(data)
        }, {
            onSuccess: () => {
                toast.success('Alterado com sucesso!')
                queryClient.invalidateQueries(['indicators_users', indicatorId])
            },
            onError: () => {
                toast.error(i18n.t('error.badRequest'));
            }
        }
    )

    const updateIndicator = async (id) => {
        const data = {
            id,
            finished: true
        }
        userMutations.mutate(data)
    }

    return (
        <div className="d-flex flex-column gap-1">
            { users.map((userList, index) => {
                return (
                    <React.Fragment key={index}>
                        {index === 0 && (
                            <div key={index} className="list-group-item border-0 border-bottom">
                                <span className="fw-bolder me-1">Prazo:</span>
                                <span className={!isOverdue(userList.deadline) ? 'text-danger' : 'text-success'}>
                                    { userList.deadline && format(parseISO(userList.deadline), 'dd/MM/yyyy') }
                                </span>
                            </div>
                        )}
                        <div key={index + '-' +userList.id} className="d-flex border-0">
                            <i className={`bi ${userList.finished ? 'bi-check-circle text-success' : 'bi-x-circle text-danger'} me-2`}/>
                            <span>{userList.username}</span>

                            {user.id === userList.user_id && !userList.finished && status === statusAuth && (
                                <div className="ms-2">
                                    <Tooltip label="Marcar como concluído">
                                        <button
                                            type="button"
                                            className="btn btn-success btn-sm p-1 py-0"
                                            onClick={() => updateIndicator(userList.id)}
                                        >
                                            <i className="bi bi-check" />
                                        </button>
                                    </Tooltip>
                                </div>
                            )}
                        </div>
                    </React.Fragment>
                )})
            }
        </div>
    )
}